import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import image from "../../../../assets/fraud-stepper/fraud-scam-stepper-description-img.png";
import { RadioGroup } from "../../../../components/forms/radio";
import { TextField } from "../../../../components/forms/text";
import { Flex } from "../../../../components/layout";
import { CryptoDTO } from "../../../../store/crypto/models/dto";
import { ReportingOptionEnum } from "../../../../store/crypto/models/internal";
import { mapObject } from "../../../../utils/utils";
import { Container, StyledWidget } from "./components";
import { useStepValidation } from "./step";

const { defaults, useFields } = CryptoDTO.Requests.CreateFraudReport;

const SideDescription = styled.p`
  flex-grow: 1;
`;

const DescriptionImage = styled.img`
  width: 20%;
`;

export const Description: React.FunctionComponent<{}> = () => {
  const { labels } = useFields();
  const { control } = useStepValidation([
    "reportType",
    "description",
    "action",
  ]);

  const { t } = useTranslation("blockchain-tools");

  return (
    <Container>
      <StyledWidget
        title={t(
          "regulary-updated-database-of-crypto-frauds-reported-by-real-victims"
        )}
      >
        <Flex>
          <SideDescription>
            {t("report-and-help-us-making-the-crypto")}
          </SideDescription>
          <DescriptionImage src={image} />
        </Flex>
      </StyledWidget>
      <StyledWidget
        title={t("are-you-a-victim-or-know-someone-who-got-scammed")}
      >
        <Controller
          control={control}
          name="reportType"
          defaultValue={defaults.reportType}
          render={({ field }) => (
            <RadioGroup<typeof ReportingOptionEnum.T>
              options={mapObject(ReportingOptionEnum.enum, (val, key) => ({
                id: key,
                label: val,
              }))}
              {...field}
            />
          )}
        />
      </StyledWidget>
      <StyledWidget title={t("brief-description-of-fraud-scam-suffered")}>
        <Controller
          control={control}
          name="description"
          defaultValue={defaults.description}
          render={({ field, fieldState: { error } }) => (
            <TextField
              fullWidth
              multiline
              rows={5}
              label={labels.description}
              error={!!error}
              helperText={error?.message}
              {...field}
            />
          )}
        />
      </StyledWidget>
      <StyledWidget title={t("actions-taken-so-far")}>
        <Controller
          control={control}
          name="action"
          defaultValue={defaults.action}
          render={({ field, fieldState: { error } }) => (
            <TextField
              fullWidth
              multiline
              rows={5}
              label={labels.action}
              error={!!error}
              helperText={error?.message}
              {...field}
            />
          )}
        />
      </StyledWidget>
    </Container>
  );
};
